import { Text } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { FC, useEffect } from "react";

import { FormControl } from "~/src/components/common/forms/FormControl";
import { FormikTextField } from "~/src/components/common/forms/FormikTextField";

import { DEFAULT_PATTERN_NAME, FormValues } from "./validationSchema";

export const WeightFields: FC<
  React.PropsWithChildren<React.PropsWithChildren<unknown>>
> = () => {
  const { values, setValues } = useFormikContext<FormValues>();

  useEffect(() => {
    setValues((currentValues) => ({
      ...currentValues,
      deliverWeights: currentValues.deliverWeights.map((d) => ({
        ...d,
        weight: d.name === DEFAULT_PATTERN_NAME ? 0 : 1,
      })),
    }));
  }, [setValues, values.deliverKind]);

  return (
    <>
      {values.deliverWeights.map((deliverWeight, i) => {
        const isDefault = deliverWeight.name === DEFAULT_PATTERN_NAME;
        const helpText = isDefault
          ? "※0以上の数値を入力してください（0は配信対象外です）"
          : "※1以上の数値を入力してください";

        return (
          <FormControl key={deliverWeight.id} label={deliverWeight.name}>
            <FormikTextField
              type="number"
              mode="fill"
              name={`deliverWeights.${i}.weight`}
              disabled={values.deliverKind === "EQUAL"}
            />
            <Text fontSize={"13px"} textColor={"#D9534F"}>
              {helpText}
            </Text>
          </FormControl>
        );
      })}
    </>
  );
};
